module.exports = __webpack_public_path__ + "static/media/uranus.d52627be.png";